import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeLayoutRoutes } from './home-layout.routing';
import { HomePageComponent } from 'src/app/pages/home-page/home-page.component';
import { MateriAlllModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { MenusPageComponent } from 'src/app/pages/menus-page/menus-page.component';
import { MenuPageComponent } from 'src/app/pages/menu-page/menu-page.component';
import { CardMenuComponent } from 'src/app/components/card-menu/card-menu.component';
import { CardProductComponent } from 'src/app/components/card-product/card-product.component';
import { MyHttpInterceptor } from 'src/app/interceptors/http.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TicketsPageComponent } from 'src/app/pages/tickets-bar-page/tickets-page.component';

import { QRCodeModule } from 'angularx-qrcode';
import { EventsPageComponent } from 'src/app/pages/events-page/events-page.component';
import { CardEventComponent } from 'src/app/components/card-event/card-event.component';
import { EventPageComponent } from 'src/app/pages/event-page/event-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TicketPageComponent } from 'src/app/pages/ticket-bar-page/ticket-page.component';
import { ProfilePageComponent } from 'src/app/pages/profile-page/profile-page.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { SelectTypePayModalComponent } from 'src/app/modals/select-type-pay-modal/select-type-pay-modal.component';
import { DivNoResultComponent } from 'src/app/components/div-no-result/div-no-result.component';
import { LoginModalComponent } from 'src/app/modals/login-modal/login-modal.component';
import { InfoMenuModalComponent } from 'src/app/modals/info-menu-modal/info-menu-modal.component';
import { TicketAccessPageComponent } from 'src/app/pages/ticket-access-page/ticket-access-page.component';
import { TicketsAccessPageComponent } from 'src/app/pages/tickets-access-page/tickets-access-page.component';
import { CheckoutTicketsEventModalComponent } from 'src/app/modals/checkout-tickets-event-modal/checkout-tickets-event-modal.component';
import { InfoEventModalComponent } from 'src/app/modals/info-event-modal/info-event-modal.component';
import { CardTicketComponent } from 'src/app/components/card-ticket/card-ticket.component';
import { BusinessPageComponent } from 'src/app/pages/business-page/business-page.component';
import { PricingPageComponent } from 'src/app/pages/pricing-page/pricing-page.component';
import { SendTicketFriendModalComponent } from 'src/app/modals/send-ticket-friend-modal/send-ticket-friend-modal.component';
import { ServicesPageComponent } from 'src/app/pages/services-page/services-page.component';

import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SpinnerLoadingComponent } from 'src/app/components/spinner-loading/spinner-loading.component';
import { CreateEventsPageComponent } from 'src/app/pages/create-events-page/create-events-page.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  imports: [
    RouterModule.forChild(HomeLayoutRoutes),
    MateriAlllModule,
    CommonModule,
    QRCodeModule,
    FormsModule,
    ZXingScannerModule,
    CarouselModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    GoogleMapsModule,
  ],

  declarations: [
    HomePageComponent,
    MenusPageComponent,
    MenuPageComponent,
    EventsPageComponent,
    TicketsPageComponent,
    TicketPageComponent,
    EventPageComponent,
    CardMenuComponent,
    CardProductComponent,
    CardEventComponent,
    ProfilePageComponent,
    SelectTypePayModalComponent,
    DivNoResultComponent,
    LoginModalComponent,
    InfoMenuModalComponent,
    TicketAccessPageComponent,
    TicketsAccessPageComponent,
    CheckoutTicketsEventModalComponent,
    InfoEventModalComponent,
    CardTicketComponent,
    PricingPageComponent,
    BusinessPageComponent,
    SendTicketFriendModalComponent,
    ServicesPageComponent,
    SpinnerLoadingComponent,
    CreateEventsPageComponent,
  ],
  bootstrap: [HomePageComponent],
  exports: [],
})
export class HomeLayoutModule {}
